import moment from 'moment';

const factors = [
  { age: 64, mlpFactor: 25.41, abpFactor: 0.04 },
  { age: 65, mlpFactor: 25.52, abpFactor: 0.05 },
  { age: 66, mlpFactor: 25.62, abpFactor: 0.05 },
  { age: 67, mlpFactor: 25.72, abpFactor: 0.05 },
  { age: 68, mlpFactor: 25.82, abpFactor: 0.05 },
  { age: 69, mlpFactor: 25.91, abpFactor: 0.05 },
  { age: 70, mlpFactor: 26, abpFactor: 0.05 },
  { age: 71, mlpFactor: 26, abpFactor: 0.05 },
  { age: 72, mlpFactor: 26, abpFactor: 0.05 },
  { age: 73, mlpFactor: 26, abpFactor: 0.05 },
  { age: 74, mlpFactor: 26, abpFactor: 0.05 },
  { age: 75, mlpFactor: 26, abpFactor: 0.06 },
  { age: 76, mlpFactor: 26, abpFactor: 0.06 },
  { age: 77, mlpFactor: 26, abpFactor: 0.06 },
  { age: 78, mlpFactor: 26, abpFactor: 0.06 },
  { age: 79, mlpFactor: 26, abpFactor: 0.06 },
  { age: 80, mlpFactor: 26, abpFactor: 0.07 },
  { age: 81, mlpFactor: 26, abpFactor: 0.07 },
  { age: 82, mlpFactor: 26, abpFactor: 0.07 },
  { age: 83, mlpFactor: 26, abpFactor: 0.07 },
  { age: 84, mlpFactor: 26, abpFactor: 0.07 },
  { age: 85, mlpFactor: 26, abpFactor: 0.09 },
  { age: 86, mlpFactor: 26, abpFactor: 0.09 },
  { age: 87, mlpFactor: 26, abpFactor: 0.09 },
  { age: 88, mlpFactor: 26, abpFactor: 0.09 },
  { age: 89, mlpFactor: 26, abpFactor: 0.09 },
  { age: 90, mlpFactor: 26, abpFactor: 0.11 },
  { age: 91, mlpFactor: 26, abpFactor: 0.11 },
  { age: 92, mlpFactor: 26, abpFactor: 0.11 },
  { age: 93, mlpFactor: 26, abpFactor: 0.11 },
  { age: 94, mlpFactor: 26, abpFactor: 0.11 },
  { age: 95, mlpFactor: 26, abpFactor: 0.14 },
];

const adjustments = [
  { endYear: 2009, adjustment: 0.5 },
  { endYear: 2010, adjustment: 0.5 },
  { endYear: 2011, adjustment: 0.5 },
  { endYear: 2012, adjustment: 0.75 },
  { endYear: 2013, adjustment: 0.75 },
  { endYear: 2020, adjustment: 0.5 },
  { endYear: 2021, adjustment: 0.5 },
  { endYear: 2022, adjustment: 0.5 },
  { endYear: 2023, adjustment: 0.5 },
];

const calculateInitialPayments = (
  commencingAge, // how old pensioner is at start of pension
  startDate, // Date() of start of pension
  initialBalance, // float of initial balance
  isTransitioning, // true/false
) => {
  const momentStartDate = moment(startDate); // Already using local from datepicker
  let endOfFinancialYear;
  let startOfFinancialYear;
  let proRateFactor = 0;
  let adjustmentFactor = 1;
  let age = commencingAge;
  if (commencingAge < 64) {
    age = 64;
  }
  if (commencingAge > 95) {
    age = 95;
  }

  // Find abp factor
  const { abpFactor } = factors.find(factor => factor.age === age);

  // Determine financial years and calculation variables
  if (momentStartDate.month() > 5) { // But I really mean 6, thanks Date() and javascript
    endOfFinancialYear = moment(`${momentStartDate.year() + 1}-06-30`).local();
    startOfFinancialYear = moment(`${momentStartDate.year()}-06-30`).local();
  } else if (momentStartDate.month() < 5) { // But I really mean 6, thanks Date() and javascript
    endOfFinancialYear = moment(`${momentStartDate.year()}-06-30`).local();
    startOfFinancialYear = moment(`${momentStartDate.year() - 1}-06-30`).local();
  } else {
    endOfFinancialYear = moment(`${momentStartDate.year()}-06-30`).local();
    startOfFinancialYear = moment(`${momentStartDate.year()}-06-30`).local();
  }

  // Find if we have an adjustment factor for this end of fin year
  const adjustmentFactorForYear = adjustments.find(
    adjustment => adjustment.endYear === endOfFinancialYear.year(),
  );
  if (adjustmentFactorForYear !== undefined) {
    adjustmentFactor = adjustmentFactorForYear.adjustment;
  }

  // Figure out how many days to pro rata (if any)
  const daysInFinancialYear = endOfFinancialYear.diff(startOfFinancialYear, 'days');
  if (daysInFinancialYear > 0) {
    const daysLeftInYear = endOfFinancialYear.diff(momentStartDate, 'days') + 1;
    proRateFactor = daysLeftInYear / daysInFinancialYear;
  }

  // Do math, round to closest $10
  return {
    minimum: Math.round((abpFactor * initialBalance * proRateFactor * adjustmentFactor) / 10) * 10,
    maximum: isTransitioning ? initialBalance * 0.1 : initialBalance,
  };
};

export default calculateInitialPayments;
